export const PRICES = {
  MULTIPLIER: 7,
  MIN_PRICE_CHOICE: 0,
  MAX_PRICE_CHOICE: 5000,
  MAX_PRICE_REQUEST: 1000000,
};
